import { render, staticRenderFns } from "./TaskListComponent.vue?vue&type=template&id=a8537b20&scoped=true"
import script from "./TaskListComponent.vue?vue&type=script&lang=js"
export * from "./TaskListComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskListComponent.vue?vue&type=style&index=0&id=a8537b20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8537b20",
  null
  
)

export default component.exports